import React, { useState } from "react";
import { connect } from "react-redux";
import {
  Row,
  Col
} from "reactstrap";
import FileCopyIcon from "@material-ui/icons/FileCopyOutlined";
import ExploreIcon from "@material-ui/icons/Explore";
import { makeStyles } from '@material-ui/core/styles';
import "./CmsSpeedDial.css";
import { Fab } from "@material-ui/core";
import RateReviewIcon from "@material-ui/icons/RateReview";
import { sourceTypes } from "../../../../constants/cms/sourceType";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Popover from "@material-ui/core/Popover";

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
}));

const CmsSpeedDial = props => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick = (event, t) => {
    if (Boolean(anchorEl)) {
      handleClose();
    }
    else {
      setAnchorEl(event.currentTarget);
    }
  };
  const loadNavItems = () => {
    return [
      {
        icon: <FileCopyIcon />,
        name: "Pages",
        paths: Array.isArray(props.pagePaths)
          ? props.pagePaths.map(p => {
            return { name: p.name, path: `./cms/page/${p.id}` };
          })
          : []
      },
      {
        icon: <RateReviewIcon />,
        name: "Forms",
        paths: Array.isArray(props.formPaths)
          ? props.formPaths.map(f => {
            return { name: f.name, path: `./cms/form/${f.id}` };
          })
          : []
      }
    ];
  };
  let currentPath = window.location.pathname;

  /* const toggleDial = () => {
    setOpen(!open);
  }; */
  const classes = useStyles();
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  return (
    <div className={"speed-dial-base"}>
      <div className={"speed-dial-wrapper"}>
        <div className={classes.root}>
          <Fab className="speed-dial" onClick={handleClick}>
            <ExploreIcon
              className="compass-icon"
              style={{ width: "30px", height: "30px" }}
            />
          </Fab>
        </div>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        style={{ zIndex: 10000, padding: "10px" }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        className="nav-options-pop"
        transformOrigin={{
          vertical: "top",
          horizontal: "center"
        }}
      >
        <Row style={{ display: "inline-block", margin: '0px', width: '100%' }}>
          <Col style={{ padding: '0px' }}>
            <NavigationPopOver
              currentPath={currentPath}
              list={loadNavItems()}
            />
          </Col>
        </Row>
      </Popover>
      {/*  {open ? (
        <div className="nav-options">
          <Row style={{ display: "inline-block", margin: '0px', width: '100%' }}>
            <Col style={{ padding: '0px' }}>
              <NavigationPopOver
                currentPath={currentPath}
                list={loadNavItems()}
              />
            </Col>
          </Row>
        </div>
      ) : null} */}
    </div>
  );
};

function mapStateToProps(state) {
  const env = state.cms.enviroment;
  let name = "";
  if (env === sourceTypes.FORM) {
    name = state.form.name;
  } else if (env === sourceTypes.PAGE) {
    name = state.page.name;
  }
  return {
    alert: state.alert,
    formPaths: state.form.paths,
    pagePaths: state.page.paths,
    cms: state.cms,
    env,
    name
  };
}
export default connect(mapStateToProps)(CmsSpeedDial);

const NavigationPopOver = props => {
  const [popoverOpen, setPopoverOpen] = useState(false);
  const toggle = () => setPopoverOpen(!popoverOpen);
  const { list } = props;
  return (
    <div>
      <List
        style={{ padding: "0px" }}
        component="nav"
        className="navigation-list"
        aria-labelledby="nested-list-subheader"
      >
        {list.map(li => {
          return li.paths.length > 0
            ? li.paths.map(p => {
              return (
                <ListItem
                  style={{
                    padding: "5px initial",
                  }}
                  button
                  onClick={() => window.location.replace(p.path)}
                >
                  <ListItemIcon
                    className={
                      props.currentPath === p.path
                        ? "jirango-active"
                        : "jirango-not-active"
                    }
                  >
                    {li.icon}
                  </ListItemIcon>
                  <ListItemText
                    className={
                      props.currentPath === p.path
                        ? "jirango-active"
                        : "jirango-not-active"
                    }
                    primary={p.name}
                  />
                </ListItem>
              );
            })
            : null;
        })}
      </List>
    </div>
  );
};
